const dev = {
  API_ENDPOINT_URL: "http://localhost:3002/",
};

const prod = {
  API_ENDPOINT_URL:
    process.env.REACT_APP_APP_NAME === "NPL Broker"
      ? "https://npl-broker.com/"
      : "https://app.loan-transfer.com/",
};

const test = {
  API_ENDPOINT_URL: "https://npl-broker.com/",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
